<template>
  <div>
    <div class="heading-5 font-weight-medium">Connect Existing Gnosis Safe</div>
    <div class="mt-8">
      <div class="h1-26-m">Input Safe Address</div>
      <p class="p-14-r darkgray--text mt-3">
        Please enter the Safe account address to load an existing Gnosis Safe to
        proceed.
      </p>
      <form class="mt-3" autocomplete="off" @submit.prevent>
        <ValidationObserver ref="observer">
          <ValidationProvider
            v-slot="{ errors }"
            name="Safe Address"
            rules="required|ethAddress"
          >
            <v-text-field
              id="firstName"
              v-model="safeAddress"
              placeholder="Safe Address"
              outlined
              class="c-input mt-2"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </ValidationObserver>
      </form>
    </div>
    <div class="p-12-r darkgray--text smoke rounded-10 pa-5 mt-3">
      By continuing, you confirm that your funds are held securely in the Gnosis
      Safe, a smart contract on the Ethereum blockchain. Funds in your Gnosis
      Safe cannot be accessed by Gnosis nor Unagii at any point.
    </div>
    <div class="mt-10 d-flex align-center justify-space-between">
      <div class="p-14-r darkgray--text clickable" @click="back">Back</div>
      <div class="d-flex justify-end align-center">
        <div class="p-16-m gray--text clickable" @click="cancel">Cancel</div>
        <c-btn @click="nextStep" class="ml-5" :loading="loadingSafeInfo"
          >Continue</c-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import web3 from "web3";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "Required.",
});
extend("ethAddress", {
  validate: value => {
    return web3.utils.isAddress(value);
  },
  message: "Must be a valid Ethereum address.",
});
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: ["safeInfo"],
  data: () => ({
    safeAddress: null,
    loadingSafeInfo: false,
  }),
  methods: {
    async loadSafeInfo() {
      const { owners, threshold } = await this.$store.dispatch(
        "userWallets/gnosis/loadSafeInfo",
        this.safeAddress
      );
      return {
        owners: owners.map(address => ({ address })),
        threshold: Number(threshold),
      };
    },
    cancel() {
      this.$store.dispatch("closeAuthModal");
    },
    back() {
      this.$emit("setStep", "1");
    },
    async nextStep() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      if (this.loadingSafeInfo) return;
      this.loadingSafeInfo = true;
      const safeInfo = await this.loadSafeInfo();
      this.$emit("setSafeInfo", {
        ...safeInfo,
        safeAddress: this.safeAddress,
      });
      // this.$emit("setStep", 3);
      this.$emit("setStep", 4);
    },
  },
  mounted() {
    if (this.safeInfo.safeAddress) {
      this.safeAddress = this.safeInfo.safeAddress;
    }
  },
};
</script>
